<template>
  <bottom-drawer-wrapper :tabTitle="'Monitoring'">
    <template #body>
      <v-row v-if="isLoading" no-gutters class="fill-height">
        <v-col cols="12" v-if="isLoading">
          <main-loader />
        </v-col>
      </v-row>
      <v-row v-else no-gutters class="fill-height" style="overflow-y: hidden; flex-wrap: nowrap;">
        <v-col
          cols="auto"
          class="pa-6"
          style="overflow-y: auto; height: 100%;"
          :class="[isSidebarVisible ? 'tab-col-withsidebar' : 'tab-col-withoutsidebar']"
        >
          <v-expansion-panels accordion focusable>
            <v-expansion-panel v-for="(tab, index) in expansionPanelTabs" :key="index">
              <v-expansion-panel-header>{{ tab.title }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <rzi-side-lists
                  :current-tab.sync="currentListsTab"
                  :current-metadata="currentMetadata"
                  :items="monitoringSiteFeatures"
                  @refreshYearGeometry="refreshYearGeometry"
                  @siteAdded="closeDialog => handleGetItems(closeDialog)"
                  :selected-site.sync="selectedSite"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-divider vertical />
        <v-col style="overflow-y: auto; height: 100%;" class="fill-height">
          <rzi-monitoring-item-section
            ref="monitoring-item-section"
            v-if="!!selectedSite"
            :key="selectedSite"
            :item="selectedSiteItem"
            :current-tab="currentListsTab"
            :current-metadata="currentMetadata"
            @itemEdited="closeDialog => handleGetItems(closeDialog)"
            @deleteSite="closeDialog => handleGetItems(closeDialog, 'delete')"
          />
        </v-col>
      </v-row>
    </template>
  </bottom-drawer-wrapper>
</template>

<script>
import BottomDrawerWrapper from '@/components/BottomDrawerWrapper';
import { monitoring } from '@/assets/js/rziData.js';
import MainLoader from '@/components/MainLoader';
import RziSideLists from '@/components/RziSideLists';
import RziMonitoringItemSection from '@/components/RziMonitoringItemSection';

import { get, call } from 'vuex-pathify';

export default {
  name: 'TabTableRziMonitoring',
  components: {
    BottomDrawerWrapper,
    MainLoader,
    RziSideLists,
    RziMonitoringItemSection,
  },
  data: () => ({
    selectedSite: null,
    monitoringSiteFeatures: [],
    isLoading: true,
    currentListsTab: 'sites',
  }),
  computed: {
    isSidebarVisible: get('sidebar/isVisible'),
    currentMetadata() {
      return monitoring;
    },
    selectedSiteItem() {
      return {
        id: this.selectedSite,
        feature: this.monitoringSiteFeatures.find(item => item.id === this.selectedSite),
      };
    },
    expansionPanelTabs() {
      return [
        {
          value: 'monitoring',
          title: this.$i18n.t('table.rziMonitoring.sites'),
        },
      ];
    },
  },
  methods: {
    getDataSourceFeatures: call('layers/getDataSourceFeatures'),
    refreshYearGeometry(closeDialog) {
      const yearSection = this.$refs['monitoring-item-section']?.$refs['monitoring-year-section'];
      if (this.selectedSite && yearSection) {
        yearSection.handleRefreshGeometries(
          Object.entries(this.currentMetadata.tableViews.geometries.datasources).map(([type, dt]) => ({
            type,
            name: dt,
          })),
          closeDialog
        );
      } else {
        closeDialog();
      }
    },
    async handleGetItems(closeDialog, type = 'edit') {
      try {
        const [monitoringSiteFeatures] = await Promise.all([
          this.getDataSourceFeatures({
            dataSource: this.currentMetadata.protectedSites.datasource,
          }),
        ]);
        this.monitoringSiteFeatures = [...monitoringSiteFeatures.features].sort((a, b) => b.id - a.id);
        if (type === 'delete') this.selectedSite = null;
        closeDialog();
      } catch (error) {
        console.error(error);
      }
    },
    async init() {
      this.isLoading = true;
      try {
        await this.handleGetItems(() => {});
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.tab-col-withsidebar {
  width: 50%;
}
.tab-col-withoutsidebar {
  width: calc(50% - (#{$map-width__hidden} - #{$map-width__visible}) / 2 - 4px);
}
:deep(.v-expansion-panel-content__wrap) {
  padding: 0 !important;
}
</style>
